/**
 * Faculty Division Assignment
 */
import { z } from 'zod';
import {
  FacultyDivisionAssignmentId,
  FacultyId,
  DivisionId,
  UnixTimestamp,
} from '../types/branded';
import { DivisionAssignmentTypeSchema } from '../types/enums';

export const FacultyDivisionAssignmentSchema = z.object({
  id: FacultyDivisionAssignmentId,
  facultyId: FacultyId,
  divisionId: DivisionId,
  assignmentType: DivisionAssignmentTypeSchema,
  isPrimary: z.boolean().optional(),
  startAt: UnixTimestamp,
  endAt: UnixTimestamp.nullable().optional(),
  allowOverlap: z.boolean().default(false),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp,
}).refine((value) => {
  if (!value.endAt) return true;
  return value.endAt >= value.startAt;
}, { message: 'endAt must be >= startAt', path: ['endAt'] });

export type FacultyDivisionAssignment = z.infer<typeof FacultyDivisionAssignmentSchema>;
